// extracted by mini-css-extract-plugin
module.exports = {"text":"Texts_text__2SJJs"};